import { SKU_TASK_TYPES } from 'volta/models/task';
import type { IWidgetTasksTypes } from '../types/tasks';

export const AVAILABLE_TASKS_TYPES: IWidgetTasksTypes = {
  assignTo: ['assignments', 'unassigned', 'assignings'],
  types: SKU_TASK_TYPES
};
